import { render, staticRenderFns } from "./Tracks.vue?vue&type=template&id=2b67056c"
import script from "./Tracks.vue?vue&type=script&lang=js"
export * from "./Tracks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports